import { Event } from '@tribeplatform/gql-client/types'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { T } from '../../../i18n/index.js'
import { getEventFormattedDate } from '../../utils.js'

import { RecurrenceList } from './RecurrenceList.js'

interface Props {
  event: Event
  open: boolean
  onClose: () => void
}

export const RecurrenceSelectorModal = ({ event, open, onClose }: Props) => {
  const { startDateTime } = getEventFormattedDate({
    startTime: event.startTime,
    endTime: event.endTime,
  })
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="2xl"
      scrollable={false}
      panelClassName="h-screen sm:h-[70dvh]"
    >
      <Modal.Header
        title={
          <T
            id="Event.Recurrence.Modal.Title"
            defaultMessage="Choose another date"
          />
        }
        description={
          <T
            id="Event.Recurrence.Modal.Description"
            defaultMessage="Currently selected: {date}."
            values={{
              date: startDateTime,
            }}
          />
        }
      />
      <Modal.Content>
        <RecurrenceList event={event} onClose={onClose} />
      </Modal.Content>
    </Modal>
  )
}
